<template>
  <div class="bg-white" :class="UI.isMobile ? 'padding-xs' : 'padding'">
    <div class="flex justify-center align-center"><h3>用户列表</h3></div>
    <el-form
      :inline="!UI.isMobile"
      :label-position="UI.isMobile ? 'top' : 'right'"
      size="mini"
      :model="filterForm"
    >
      <el-form-item label="用户名">
        <el-input
          clearable
          v-model="filterForm.username"
          placeholder="请输入"
        ></el-input>
      </el-form-item>

      <el-form-item label="手机">
        <el-input
          clearable
          v-model="filterForm.mobile"
          placeholder="请输入"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          @click="
            page = 1;
            filterForm = { page: 1, page_size: 10 };
            flushData();
          "
        >
          查询
        </el-button>
        <el-button
          @click="
            filterForm = { page: 1, page_size: 10 };
            flushData();
          "
        >
          重置
        </el-button>
        <el-button
          type="primary"
          @click="
            handleExportExcel();
          "
        >
          导出
        </el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="username" label="用户名"></el-table-column>
      <el-table-column
        prop="mobile"
        label="手机"
        v-if="!UI.isMobile"
      ></el-table-column>

      <el-table-column label="角色" v-if="!UI.isMobile">
        <template slot-scope="scope">
          {{ $getRoleLabel(scope.row.role) }}
        </template>
      </el-table-column>

      <el-table-column label="查看信息" v-else>
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="
              info = scope.row;
              isInfoShow = true;
            "
          >
            点击查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="flex justify-center align-center full-width margin-top">
      <el-pagination
        :hide-on-single-page="total <= filterForm.page_size"
        @current-change="handleCurrentChange"
        :current-page.sync="filterForm.page"
        :page-size="filterForm.page_size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog
      show-close
      :fullscreen="UI.isMobile"
      title="查看"
      :visible.sync="isInfoShow"
      width="98%"
      v-if="UI.isMobile"
    >
      <div class="padding-xs">
        <el-descriptions :column="1" border>
          <el-descriptions-item
            v-for="(value, key) in info"
            :key="key"
            :label="key"
          >
            <div v-if="!(value + '').startsWith('http')">{{ value }}</div>
            <div v-else>
              <el-button
                type="primary"
                size="small"
                @click="
                  fileUrl = value;
                  isShow = true;
                "
              >
                点击查看
              </el-button>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>

    <el-dialog
      title="查看"
      :visible.sync="isShow"
      width="800px"
      show-close
      :fullscreen="UI.isMobile"
    >
      <pdf :src="fileUrl" v-if="fileUrl.endsWith('pdf')"></pdf>
      <img v-else :src="fileUrl" style="max-width: 500px;"></img>
    </el-dialog>
  </div>
</template>

<script>
import { getUserList } from '@/servers/admin.js';
import { mapState } from 'vuex';
import pdf from '@/components/pdfShow.vue';
import XLSX from 'xlsx';

export default {
  components: {
    pdf,
  },

  data() {
    return {
      info: {},
      isInfoShow: false,
      isShow: false,
      fileUrl: '',
      filterForm: {
        page: 1,
        page_size: 10,
      },
      total: 0,
      tableData: [],
      approveBtn: ['warning', 'success', 'danger'],
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  created() {
    this.flushData();
  },

  methods: {

    handleExportExcel: function(name, result) {
      this.filterForm.page_size = 100000
      let that = this
      getUserList(this.filterForm, function(res) {
        let userList = res.items
        userList.sort((a, b) => {
          return a.role - b.role
        })
        const sheetData1 = userList.map((item) => ({
          注册用户名: item.username,
          注册手机号码: item.mobile,
          注册ID: item.user_id,
          姓名: item.user_info.name,
          角色: that.$getRoleLabel(item.role),
          照片: item.user_info.avatar,
          性别: item.user_info.sex == 0 ? '男': '女',
          籍贯: item.user_info.native_place.join(),
          民族: item.user_info.nation,
          联系电话: item.user_info.mobile,
          邮箱: item.user_info.email,
          生日: item.user_info.birthday,
          地址: item.user_info.address,
          签名: item.user_info.sign,
          裁判等级: item.user_info.referee_level,
          赛事履历: item.user_info.referee_resume,
          身份证号: item.user_info.identifier_code,
          证件照片: item.user_info.identifier_image,
          户籍证明: item.user_info.household_image,
          代表资格协议: item.user_info.contract,
          协议时间: `${item.user_info.contract_start_time} -> ${item.user_info.contract_end_time}`,
          信息状态: that.$getApproveLabel(item.user_info.is_approved),
          单位: item.organization_info.organization,
          单位地址: item.organization_info.address,
          单位联系人: item.organization_info.contact,
          单位联系电话: item.organization_info.contact_phone,
          单位联系手机: item.organization_info.contact_mobile,
          单位邮箱: item.organization_info.email,
          认证文件: item.organization_info.auth_file,
          单位信息状态: that.$getApproveLabel(item.organization_info.is_approved),
        }));
        const sheet1 = XLSX.utils.json_to_sheet(sheetData1);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, sheet1, '注册名单');
        XLSX.writeFile(wb, `注册名单-${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}.xlsx`);
      });
    },

    flushData: function() {
      let that = this;
      getUserList(this.filterForm, function(res) {
        that.tableData = res.items;
        that.total = res.total;
      });
    },

    handleCurrentChange: function() {
      this.flushData();
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/index/approve/userList.vue